import { render, staticRenderFns } from "./SpaceExportTransactions.vue?vue&type=template&id=39853322&"
import script from "./SpaceExportTransactions.vue?vue&type=script&lang=js&"
export * from "./SpaceExportTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports